import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CheckSquareOutlined } from '@ant-design/icons';

import Modal from '../../../../../components/Modal';
import DragSortListWrap from '../../../../../components/DragSortListWrap';
import Img from '../../../../../components/Img/Img';
import todayDeliveryBadgeIcon from '../../../../../static/images/common/today_delivery_badge_icon.png';
import { reOrderArray, setDash } from '../../../../../lib/common';
import { productActions } from '../../../../../store/modules/product';
import {
  PRODUCT_MANAGEMENT_TYPE,
  PRODUCT_OPTION_STATUS_TEXT,
  PRODUCT_MANAGEMENT_TYPE_TEXT,
} from '../../../../../constants/service/app/productConstants';
import './EditProductOptionOrderModal.scss';

const EditProductOptionOrderModal = (props) => {
  const { isOpen, optionKeyName, optionList, setOptionList } = props;
  const [tempOptionList, setTempOptionList] = useState(optionList);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(
      productActions.toggleModal({
        name: 'editProductOptionOrderModal',
        value: false,
      }),
    );
  };

  const onChangeProductOptionNo = async (result) => {
    if (!result.destination) {
      return;
    }

    const list = reOrderArray(tempOptionList, result.source.index, result.destination.index);

    setTempOptionList(list);
  };

  const onSubmit = () => {
    setOptionList(tempOptionList);
    closeModal();
  };

  return (
    <Modal
      title={'상품 옵션 순서 변경'}
      wrapClassName="edit-product-option-order-modal-wrapper"
      isOpen={isOpen}
      width={700}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText="저장하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <DragSortListWrap
        onDragEnd={onChangeProductOptionNo}
        list={tempOptionList}
        droppableId="dragSortImgList"
        item={(data, index) => (
          <div key={index} className="product-option-item">
            <div className="product-option-order">{index + 1}.</div>
            <div className="product-option-info">
              <div>
                <div>
                  <span>{optionKeyName}:</span> {setDash(data.name)}
                </div>
                <div>
                  <span>바코드:</span> {setDash(data.styleCode)}
                </div>
              </div>
              <div>
                <div>
                  <span>상품관리타입:</span> {PRODUCT_MANAGEMENT_TYPE_TEXT[data.productManagementType]}
                </div>
                <div>
                  <span>상태:</span> {PRODUCT_OPTION_STATUS_TEXT[data.status]}
                </div>
              </div>
            </div>
            <div className="today-delivery-badge-icon-wrap">
              {data.productManagementType !== PRODUCT_MANAGEMENT_TYPE.ENTER ? (
                <Img className="today-delivery-badge-icon" clickAble={false} src={todayDeliveryBadgeIcon} />
              ) : null}
              {data.selected && <CheckSquareOutlined />}
            </div>
          </div>
        )}
      />
    </Modal>
  );
};

export default EditProductOptionOrderModal;
